import { ActionTypes, LoadingAction } from './actions';

export interface LoadingState {
  visible: boolean;
  loadingText?: string;
}

const initialState: LoadingState = {
  visible: false,
};

export default function reduce(
  state: LoadingState = initialState,
  action: LoadingAction
): LoadingState {
  switch (action.type) {
    case ActionTypes.ShowLoading:
      return {
        ...state,
        visible: true,
        loadingText: action.loadingText,
      };
    case ActionTypes.HideLoading:
      return {
        ...state,
        visible: false,
        loadingText: undefined,
      };
    default:
      return state;
  }
}
